import React from 'react';
import { IMyRequestsComponentProps } from './my-requests.props';
import { defaultMyRequestsComponentState, IMyRequestsComponentState } from './my-requests.state';
import { MyRequestsComponentMode } from './my-requests-mode.enum';
import { PqrWebService } from '../../services/services';
import { IRadicadoEntradaExtended } from '../../classes/radicado-entrada-extended';
import { EstadoRadicado, EstadoRadicadoSalida } from '../../ioip/sdk/base';
import { DefaultButton, SelectionMode, IContextualMenuItem } from "@fluentui/react";
import { MsalAuthProvider, LoginType, AuthenticationState } from "react-aad-msal";
import { GenericDataTableComponent } from 'ioip-base/lib/common';

export class MyRequestsComponent extends React.Component<IMyRequestsComponentProps, IMyRequestsComponentState> {

  private _pqrWebService: PqrWebService;
  private _authProvider: MsalAuthProvider;

  constructor(props: any) {
    super(props);
    this.state = defaultMyRequestsComponentState();
    this._pqrWebService = new PqrWebService();

    this._authProvider = new MsalAuthProvider(
      {
        auth: {
          authority: sessionStorage[ 'Authority' ],
          clientId: sessionStorage[ 'ClientId' ],
          postLogoutRedirectUri: window.location.origin + '/sede.html',
          redirectUri: window.location.origin + '/sede.html',
          validateAuthority: false,
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: true
        }
      },
      {
        scopes: [ sessionStorage[ 'Scopes' ] ]
      },
      {
        loginType: LoginType.Popup,
        tokenRefreshUri: window.location.origin
      }
    );

  }


  render(): JSX.Element {
    return (
      <div className=''>
        <div className='card'>
          <GenericDataTableComponent
            refreshOnInit={true}
            allowSearch={true}
            primaryKey='IdContacto'
            service={this._pqrWebService as any}
            paginationMethodName={this.getMethod()}
            columnsAllowedToOrder={[]}
            selectionMode={SelectionMode.single}
            columns={[
              {
                key: 'Número',
                name: 'Número',
                fieldName: 'NumeroRadicado',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true
              },
              {
                key: 'Tramite',
                name: 'Trámite',
                fieldName: 'Tramite',
                minWidth: 200,
                maxWidth: 300,
                isResizable: true
              },
              {
                key: 'Clasificación',
                name: 'Clasificación',
                fieldName: 'ClasificacionPQRS',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                isSorted: false
              },
              {
                key: 'FechaCreacionString2',
                name: 'Fecha de Creación',
                fieldName: 'FechaCreacionString2',
                minWidth: 120,
                maxWidth: 120,
                isSorted: false,
                isResizable: true
              },
              {
                key: 'Estado',
                name: 'Estado',
                fieldName: 'Estado',
                maxWidth: 300,
                minWidth: 200,
                isResizable: true,
                onRender: (item: IRadicadoEntradaExtended) => {
                  if (item.IdEstadoActual !== EstadoRadicado.EnTramite) {
                    return item.Estado;
                  } else {
                    return 'En trámite';
                    //}
                  }
                }
              }
            ]}
            title={'Mis solicitudes'}
            searchTooltip='Buscar solicitudes filtrando por el número de radicado'
            commandBarItems={this.state.commandBar}
            onSelectedRow={this._onSelectedRow.bind(this)}
          />
        </div>

        <div className='row'>
          <div className='col' style={{ textAlign: 'right', paddingTop: '15px' }}>
            <DefaultButton
              text='Volver a inicio'
              href='#/home'
            />
          </div>
        </div>
      </div >
    );
  }

  private getMethod(): string {
    var method: string;
    if (this.props.mode === MyRequestsComponentMode.MyRequests) {
      method = 'getMyRequestsAsync';
    }
    else {
      method = 'getAnonymousRequestsAsync'
    }
    return method;
  }

  private async _onSelectedRow(rows: IRadicadoEntradaExtended[]) {
    if (rows.length > 0) {
      this.setState({
        commandBar: await this._buildCommandBar(rows[ 0 ]),
        IdRadicadoEntradaSelected: rows[ 0 ].IdRadicadoEntrada
      });
    }
  }

  private async _buildCommandBar(selectedItem: IRadicadoEntradaExtended): Promise<IContextualMenuItem[]> {
    const commandBar: IContextualMenuItem[] = [];
    if (selectedItem) {
      commandBar.push(
        {
          key: 'Descargar solicitud',
          name: 'Descargar solicitud',
          iconProps: { iconName: 'Download' },
          onClick: () => {
            this._downloadRadicadoEntrada(selectedItem.IdRadicadoEntrada);
          }
        },
        {
          key: 'Descargar anexos',
          name: 'Descargar anexos',
          iconProps: { iconName: 'Download' },
          onClick: () => {
            this._downloadAnexosRadicadoEntrada(selectedItem.IdRadicadoEntrada);
          }
        }
      );
      if (selectedItem.IdRadicadoSalida != null && selectedItem.IdEstadoActualRadicadoSalida === EstadoRadicadoSalida.Aprobado) {
        commandBar.push(
          {
            key: 'Descargar respuesta',
            name: 'Descargar respuesta',
            iconProps: { iconName: 'Download' },
            onClick: () => {
              this._downloadRadicadoSalida(selectedItem.IdRadicadoSalida);
            }
          }
        );
        if (await this._verifyAttachmentsRadicadoSalida(selectedItem.IdRadicadoSalida)) {
          commandBar.push(
            {
              key: 'Descargar anexos respuesta',
              name: 'Descargar anexos respuesta',
              iconProps: { iconName: 'Download' },
              onClick: () => {
                this._pqrWebService.downloadAttactmentsRadicadoSalida(selectedItem.IdRadicadoSalida);
              }
            });
        }
      }
    }
    return commandBar;
  }

  private async _getTokenB2C() {

    if (this._authProvider !== undefined) {
      if (this._authProvider.authenticationState == AuthenticationState.Authenticated) {
        const token = await this._authProvider.getIdToken();
        if (token !== undefined)
          sessionStorage.setItem('ioip.pqr-web.session.token', token.idToken.rawIdToken);
      }
    }
  }

  private async _downloadRadicadoEntrada(IdRadicadoEntrada: number) {
    this._getTokenB2C();
    this._pqrWebService.downloadRadicadoEntrada(IdRadicadoEntrada);
  }

  private async _downloadAnexosRadicadoEntrada(IdRadicadoEntrada: number) {
    this._getTokenB2C();
    this._pqrWebService.downloadAnexosRadicadoEntrada(IdRadicadoEntrada);
  }

  private async _downloadRadicadoSalida(IdRadicadoSalida: number) {
    this._getTokenB2C();
    this._pqrWebService.downloadRadicadoSalida(IdRadicadoSalida);
  }

  private async _verifyAttachmentsRadicadoSalida(idRadicadoSalida: number): Promise<boolean> {
    const result: boolean = await this._pqrWebService.verifyAttachmentsRadicadoSalidaAsync(idRadicadoSalida);
    return result;
  }

}